import { useQuery } from '@tanstack/react-query';
import { queryKeys, staleTimes } from '../config/queryClient';

/**
 * Hook para obtener el logo de una sucursal
 * 
 * Nota: En lugar de cargar como blob, ahora usamos la URL directa
 * para aprovechar el caché HTTP del navegador
 * 
 * @param {number} shopBranchId - ID de la sucursal
 * @param {object} options - Opciones adicionales
 * @returns {object} - { data: logoUrl, isLoading, error }
 */
export const useLogoImage = (shopBranchId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.logo(shopBranchId),
    
    queryFn: async () => {
      // Usar URL directa para aprovechar caché HTTP del navegador
      // No hacemos HEAD request porque puede fallar por CORS
      // Si la imagen no existe, el navegador manejará el error en el tag <img>
      const logoUrl = `${process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_LOGO_IMAGE}/${shopBranchId}`;
      return logoUrl;
    },
    
    enabled: !!shopBranchId,
    
    // Logo casi nunca cambia
    staleTime: staleTimes.static, // 1 hora
    
    cacheTime: 2 * 60 * 60 * 1000, // 2 horas
    
    // No fallar si la imagen no existe, simplemente retornar la URL
    retry: false,
    
    ...options,
  });
};
